import type React from "react";
import "country-flag-icons/react/3x2";
import * as Flags from "country-flag-icons/react/3x2";

const supportedCountryCodes = [
  "AE",
  "AI",
  "AL",
  "AM",
  "AR",
  "AT",
  "AU",
  "AZ",
  "BA",
  "BD",
  "BE",
  "BG",
  "BH",
  "BN",
  "BO",
  "BR",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CG",
  "CH",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CY",
  "CZ",
  "DE",
  "DK",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "ES",
  "FI",
  "FR",
  "GB",
  "GE",
  "GH",
  "GR",
  "GT",
  "HK",
  "HR",
  "HU",
  "ID",
  "IE",
  "IL",
  "IN",
  "IQ",
  "IS",
  "IT",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KR",
  "KW",
  "KZ",
  "LA",
  "LI",
  "LK",
  "LT",
  "LU",
  "LV",
  "MA",
  "MC",
  "MD",
  "MM",
  "MO",
  "MR",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NG",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PH",
  "PK",
  "PL",
  "PR",
  "PT",
  "PW",
  "PY",
  "QA",
  "RO",
  "RU",
  "SA",
  "SC",
  "SE",
  "SG",
  "SI",
  "SK",
  "SL",
  "ST",
  "TH",
  "TJ",
  "TM",
  "TN",
  "TO",
  "TR",
  "TW",
  "TZ",
  "UA",
  "US",
  "UY",
  "UZ",
  "VE",
  "VN",
  "ZA",
  "ZM",
  "ZW",
];

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const uniqueSupportedCountryCodes = Array.from(new Set(supportedCountryCodes));

export const countries = uniqueSupportedCountryCodes
  .map((code) => {
    const FlagComponent = (Flags as Record<
      string,
      React.FC<React.SVGProps<SVGSVGElement>>
    >)[code];
    const name = regionNames.of(code) || code;

    return {
      code,
      name,
      icon: FlagComponent ? (
        <div className="w-[20px] h-[20px] rounded-full overflow-hidden ring ring-gray-300 mr-2">
          <FlagComponent
            style={{ width: "30px", height: "20px", transform: "translate(-5px, 0px)" }}
          >
            <title>{name}</title>
          </FlagComponent>
        </div>
      ) : (
        <div className="w-[20px] h-[20px] rounded-full bg-gray-200 mr-2 text-[10px] flex items-center justify-center uppercase">
          {code}
        </div>
      ),
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));
